import React, { FunctionComponent } from 'react';
import { Checkbox } from '@inplayer-org/inplayer-ui';

// hooks
import useRestrictionRules from 'restrictions/roles/hooks/useRestrictionRules';

// constants
import Rules from 'restrictions/roles/constants/rules';

interface OwnProps {
  inplayer_protected_label: boolean;
  handleCheckboxChange: (elementName: string, checked: boolean) => any;
}

const PaywallConfigurationContent: FunctionComponent<OwnProps> = ({
  inplayer_protected_label,
  handleCheckboxChange,
}) => {
  const { hasRule } = useRestrictionRules();
  const isReadOnly = hasRule(Rules.READONLY_BRANDING_THEMES);

  return (
    <>
      <>
        <Checkbox
          tag="checkbox_protection_label"
          checked={inplayer_protected_label}
          name="inplayer_protected_label"
          id="inplayer_protected_label"
          label="Protection label"
          onChange={handleCheckboxChange('inplayer_protected_label', !inplayer_protected_label)}
          disabled={isReadOnly}
        />
      </>
    </>
  );
};

export default PaywallConfigurationContent;
